module.exports = __webpack_public_path__ + "img/supervision_1920.61710f4d.webp";